import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import { UDV_SURFACE, udvDialogProps } from './udvSurface'
import GsdfQaView from './GsdfQaView'
import {
  getGsdfQaResult,
  setGsdfQaPassed,
  clearGsdfQaResult,
  isGsdfQaPassed,
} from '../utils/gsdfQaPrefs'

class GsdfQaModal extends Component {
  constructor(props) {
    super(props)
    const prev = getGsdfQaResult()
    const passed = !!(prev && prev.gsdf_qa_passed)
    this.state = {
      checkD05: passed,
      checkD95: passed,
      checkRamp: passed,
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      const prev = getGsdfQaResult()
      const passed = !!(prev && prev.gsdf_qa_passed)
      this.setState({
        checkD05: passed,
        checkD95: passed,
        checkRamp: passed,
      })
    }
  }

  allChecked = () => {
    const { checkD05, checkD95, checkRamp } = this.state
    return !!(checkD05 && checkD95 && checkRamp)
  }

  handleSave = () => {
    const { onClose, onResultChange } = this.props
    let result = null
    if (this.allChecked()) {
      result = setGsdfQaPassed()
    } else {
      clearGsdfQaResult()
    }
    if (onResultChange) {
      onResultChange(result, isGsdfQaPassed())
    }
    if (onClose) onClose()
  }

  handleClose = () => {
    if (this.props.onClose) this.props.onClose()
  }

  render() {
    const { open = true, t } = this.props
    const { checkD05, checkD95, checkRamp } = this.state
    const canPass = this.allChecked()

    return (
      <Dialog
        open={!!open}
        onClose={this.handleClose}
        fullScreen
        {...udvDialogProps}
        PaperProps={{
          ...udvDialogProps.PaperProps,
          style: {
            ...UDV_SURFACE.paper,
            borderRadius: 0,
            display: 'flex',
            flexDirection: 'column',
            background: '#0a0c10',
          },
        }}
      >
        <DialogTitle
          disableTypography
          style={{
            ...UDV_SURFACE.title,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            margin: 0,
            padding: '10px 12px',
          }}
        >
          <Typography variant="h6" style={{ fontSize: '1rem', fontWeight: 600 }}>
            {t('gsdfQa.title')}
          </Typography>
          <IconButton
            size="small"
            onClick={this.handleClose}
            aria-label={t('common.close')}
            style={{ color: '#e8eef4' }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        <DialogContent
          style={{
            ...UDV_SURFACE.content,
            flex: 1,
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            padding: 0,
            overflow: 'hidden',
            background: '#000000',
          }}
        >
          <div
            style={{
              flex: '1 1 280px',
              minWidth: 0,
              minHeight: 220,
              background: '#000000',
            }}
          >
            <GsdfQaView />
          </div>

          <aside
            style={{
              flex: '0 1 280px',
              width: 280,
              maxWidth: '100%',
              minWidth: 200,
              padding: '14px 16px',
              background: 'rgba(18, 22, 28, 0.98)',
              borderLeft: '1px solid rgba(100, 181, 246, 0.18)',
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
              boxSizing: 'border-box',
            }}
          >
            <Typography
              variant="caption"
              style={{ ...UDV_SURFACE.muted, lineHeight: 1.45, marginBottom: 6 }}
            >
              {t('gsdfQa.disclaimer')}
            </Typography>

            <FormControlLabel
              control={
                <Checkbox
                  checked={!!checkD05}
                  onChange={(e) => this.setState({ checkD05: e.target.checked })}
                  color="primary"
                  size="small"
                />
              }
              label={
                <Typography variant="body2" style={{ fontSize: '0.82rem', lineHeight: 1.35 }}>
                  {t('gsdfQa.checkD05')}
                </Typography>
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!checkD95}
                  onChange={(e) => this.setState({ checkD95: e.target.checked })}
                  color="primary"
                  size="small"
                />
              }
              label={
                <Typography variant="body2" style={{ fontSize: '0.82rem', lineHeight: 1.35 }}>
                  {t('gsdfQa.checkD95')}
                </Typography>
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!checkRamp}
                  onChange={(e) => this.setState({ checkRamp: e.target.checked })}
                  color="primary"
                  size="small"
                />
              }
              label={
                <Typography variant="body2" style={{ fontSize: '0.82rem', lineHeight: 1.35 }}>
                  {t('gsdfQa.checkRamp')}
                </Typography>
              }
            />

            <Typography
              variant="caption"
              style={{
                marginTop: 12,
                color: canPass ? '#66bb6a' : '#ffca28',
                fontWeight: 600,
              }}
            >
              {canPass ? t('gsdfQa.badgeOk') : t('gsdfQa.badgeUnverified')}
            </Typography>
          </aside>
        </DialogContent>

        <DialogActions style={UDV_SURFACE.actions}>
          <Button onClick={this.handleClose} style={UDV_SURFACE.btnGhost}>
            {t('common.cancel')}
          </Button>
          <Button
            onClick={this.handleSave}
            variant="contained"
            style={UDV_SURFACE.btnPrimary}
            disabled={!canPass}
          >
            {t('gsdfQa.saveClose')}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withTranslation()(GsdfQaModal)
